const uiComponentNavContainer = document.querySelector('.wp-block-hs-blocks-ui-component-nav-container') || false;

if(uiComponentNavContainer.classList.contains('mode-breakpoint')){

    const breakpoint = uiComponentNavContainer.dataset.navBreakpoint;
    let lastWidht = 0;
    
    hs_core.addTask(()=>{
        if(window.innerWidth === lastWidht){
            return;
        }

        if(window.innerWidth >= breakpoint){
            uiComponentNavContainer.classList.add('mode-desktop')
            uiComponentNavContainer.classList.remove('mode-mobile')
        }else{
            uiComponentNavContainer.classList.add('mode-mobile')
            uiComponentNavContainer.classList.remove('mode-desktop') 
        }

        uiComponentNavContainer.classList.remove('hidden');
        lastWidht = window.innerWidth;
    })
}
